import { FC, useMemo, useCallback } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { opportunityCategoriesSelector } from 'selectors/oppertunitiesSelectors'
import { InsightCategoriesRibbon } from 'components/features/insights/InsightCategoriesRibbon/InsightCategoriesRibbon'
import { OPPORTUNITIES_PAGE_PLACEMENT } from 'constants/opportunities'
import { OPPORTUNITIES_PAGE } from 'constants/pages'
import { setFilterCategoryActionCreator } from 'actions/globalActions'
import { activateAnchorActionCreator } from 'actions/navigationActions'
import { OpportunityCategoryId } from 'interfaces/meta'
import { useSelectedCategoryId } from 'helpers/hookHelpers'

export const OpportunitiesCategoryMenu: FC = () => {
  const withPlacement = useMemo(() => ({ placement: OPPORTUNITIES_PAGE_PLACEMENT }), [])
  const categories = useStoreSelector((state) => opportunityCategoriesSelector(state, withPlacement))

  const selectedCategoryId = useSelectedCategoryId(OPPORTUNITIES_PAGE)

  const dispatch = useStoreDispatch()
  const handleCategorySelect = useCallback<(id: OpportunityCategoryId) => void>((id) => {
    dispatch(setFilterCategoryActionCreator(OPPORTUNITIES_PAGE, id))
    dispatch(activateAnchorActionCreator(OPPORTUNITIES_PAGE))
  }, [dispatch])

  if (!categories) {
    return null
  }

  return (
    <InsightCategoriesRibbon
      categories={ categories }
      selectedCategoryId={ selectedCategoryId }
      onCategorySelect={ handleCategorySelect }
    />
  )
}
